import './style.css';

// =========================================================================
// WEBAUDIO RENDERER & AUDIO DEVICE ERROR SHIELD
// Previene que Chromium (Chrome/Edge) inunde la consola con:
// "The AudioContext encountered an error from the audio device or the WebAudio renderer."
// cuando no hay dispositivo de audio activo, está suspendido por el sistema
// o el usuario aún no ha realizado interacción física en la página.
// =========================================================================
if (typeof window !== 'undefined') {
  const AudioContextClass = window.AudioContext || window.webkitAudioContext;

  // Interceptar eventos de error no capturados relacionados con AudioContext
  window.addEventListener('error', (e) => {
    if (e && e.message && typeof e.message === 'string' && e.message.includes('AudioContext')) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  // Wrapper defensivo sobre window.AudioContext si existe en el entorno
  if (AudioContextClass) {
    try {
      const SafeAudioContext = class extends AudioContextClass {
        constructor(options) {
          try {
            super(options);
            this.addEventListener('error', (err) => {
              if (err && typeof err.preventDefault === 'function') err.preventDefault();
            });
          } catch (_) {
            // Fallback silencioso si el hardware de sonido falla
          }
        }
      };

      window.AudioContext = SafeAudioContext;
      if (window.webkitAudioContext) {
        window.webkitAudioContext = SafeAudioContext;
      }
    } catch (_) {
      // Ignorar si el navegador tiene el objeto sellado
    }
  }
}

console.log('InstaPlay Latam loaded successfully!');

